import React from 'react';

import type { LinkProps } from '../../interfaces/linkProps';
import { StyledTextButton } from './styles';
import { Anchor } from '@zillow/constellation';

type Props = {
  children: React.ReactNode;
  escape?: boolean;
  // Link component from react-router or next.js
  link?: React.ComponentType<React.PropsWithChildren<LinkProps>>;
  name?: string;
  path: string | null;
  target?: string;
  title?: string | React.ReactNode;
  useAbsolutePaths?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLElement, MouseEvent> | undefined) => void | null;
};

const AdaptiveAnchor = ({
  children,
  escape = false,
  link,
  path,
  target = '_self',
  title,
  useAbsolutePaths = false,
  onClick,
}: Props) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  // use link via router
  if (!useAbsolutePaths && !escape && link && target === '_self') {
    return (
      // @ts-ignore issue with the component children
      <StyledTextButton
        data-testid="AdaptiveAnchor-Link"
        // @ts-ignore issue with the link interface
        tabIndex={-1}
        // @ts-ignore issue with the link interface
        as={link}
        // @ts-ignore issue with the link interface
        to={path}
        onClick={handleClick}
        aria-label={title}
        title={title}
        aria-labelledby={title}
      >
        {children}
      </StyledTextButton>
    );
  }

  // use anchor
  return (
    <StyledTextButton
      data-testid="AdaptiveAnchor-Anchor"
      tabIndex={-1}
      title={title}
      as={Anchor}
      href={path}
      target={target}
      onClick={handleClick}
      aria-label={title}
      aria-labelledby={title}
    >
      {children}
    </StyledTextButton>
  );
};

export default AdaptiveAnchor;
